import { HowtobuyData } from "../../../hooks/useApiCalls";
import BuyCard from "./components/BuyCard";
import BuyDetail from "./components/BuyDetail";


function HowToBuy() {

    const howtobuy = HowtobuyData();
    const steps = howtobuy.steps ? howtobuy.steps : [];
    const side = howtobuy.side ? howtobuy.side:{};

    
    
    return ( 
       <>
       <section id="how-to-buy" className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">

              {steps.map((data)=>{

                return <BuyCard order={data.rank} 
                                title = {data.title} 
                                detail={data.comment} 
                         />;
              })}
             </div>
            
            <BuyDetail side = {side}/>
          </div>
        </div>
      </section>
    </> 
 ); 

}

export default HowToBuy;